const STATUS_COLORS: Record<string, string> = {
  Active: "#00B189",
  Expired: "#FE5E5B",
};

/** Brand-aligned accent colour for a reusable RTP status. */
export const accentFor = (status: string) => STATUS_COLORS[status] ?? "#7B8A9E";
